import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { Raphael,Image ,Path , Rect, Paper, Set, Circle, Ellipse, Text } from "react-raphael";
import carroA from '../../../../assets/images/Unidad/BusesXLado/imgBusA.png'
import carroB from '../../../../assets/images/Unidad/BusesXLado/imgBusB.png'

import busRojo from '../../../../assets/images/Unidad/BusRojo16x16.gif'
import busAzul from '../../../../assets/images/Unidad/BusAzul16x16.gif'
import { useMonitoreoV2 } from '../../../../hooks/monitoreo/useMonitoreoV2';
import { utilLeaflet } from '../../../../utils/utilLeaflet';

const ContenedorModalMonitoreo = ({
	codEmpresa = 0, 
	codRuta = 0, 
	nombreEmpresaSeleccionada = '',
	nombreRutaSeleccionada = ''
}) => {

	const leafletClass = useMemo(() => new utilLeaflet(), []);

	const rafaRef = useRef()
	const timerTrackRef = useRef() 
	const mapLeafletRef = useRef()
	const marcadoresMapaRef = useRef([])
	const placaMarcadorSeleccionadoRef = useRef("")

	const {
		listarTrackUnidades,
		trackUnidades,
		trackUnidadesA,
		trackUnidadesB,
		alertas,
		listarControles,
		controlesA,
		distanciaTotalA,
		controlesB,
		distanciaTotalB,
		listarPolilineasRecorridos,
		polilineas,
	} = useMonitoreoV2()

	const [anchoRectPequenio,setAnchoRectPequenio] = useState(0)
	const [anchoRectGrande,setAnchoRectGrande] = useState(0)
	const [verControlCompletoA,setVerControlCompletoA] = useState(false)
	const [nombreControlCompletoA,setNombreControlCompletoA] = useState(false)
	const [verControlCompletoB,setVerControlCompletoB] = useState(false)
	const [nombreControlCompletoB,setNombreControlCompletoB] = useState(false)

	useEffect(() => {
		(async () => {
			leafletClass.inicializarMapa({mapDiv: mapLeafletRef.current});
			setTimeout(() => {
					setAnchoRectPequenio(rafaRef.current.offsetWidth - 200)
					setAnchoRectGrande(rafaRef.current.offsetWidth - 85)
			}, 600);

			await listarPolilineasRecorridos(codEmpresa, codRuta)
			await listarControles(codEmpresa, codRuta)
			await listarTrackUnidades(codEmpresa, codRuta)
			timerTrackRef.current = setInterval(async () => {
				await listarTrackUnidades(codEmpresa, codRuta)
			}, 15000)
		})();

		return () => {
			clearInterval(timerTrackRef.current)
		}
	}, [])

	useEffect(() => {
		if(trackUnidades.length != 0){
			leafletClass.eliminarTodosLosMarcadores()
			marcadoresMapaRef.current = [];

			trackUnidades.forEach((data,i) => {
				const contenidoPopUp = 
				`<div style="display:grid;grid-template-columns:auto auto 1fr;gap:6px;width: 300px">
						<div>Posteo</div>
						<div>:</div>
						<div style="font-weight: 600">${data.fechaHoraPaso}</div>
						<div>Padrón</div>
						<div>:</div>
						<div style="font-weight: 600">${data.padron} ${data.placa}</div>
						<div>Velocidad</div>
						<div>:</div>
						<div style="font-weight: 600">${data.velocidadRegistro} Km/h</div>
						<div>Sentido</div>
						<div>:</div>
						<div style="font-weight: 600">${data.predeterminado}</div>
						<div>Conductor</div>
						<div>:</div>
						<div style="font-weight: 600">${data.conductor}</div>
						<div>F.Despacho</div>
						<div>:</div>
						<div style="font-weight: 600">${data.fechaSalida || '-'}</div>
						<div>Orientación</div>
						<div>:</div>
						<div style="font-weight: 600">${data.rumbo}</div>
				</div>`;
				
				const marcadorCreado = leafletClass.crearMarcador({
					lat: data.latitudRegistro,
					lng: data.longitudRegistro,
					icono: data.lado =='A' ? busAzul : busRojo,
					contenidoPopUp: contenidoPopUp
				});

				if(placaMarcadorSeleccionadoRef.current == data.placa){
					leafletClass.centrarMarcador(marcadorCreado)
					leafletClass.abrirPopUpMarcador(marcadorCreado, () => {		// EVENTO PARA CUANDO SE DE CLICK EN LA "X" DEL POPUP
						placaMarcadorSeleccionadoRef.current = "";
					})
				}

				marcadorCreado.on("popupopen", function(){
					placaMarcadorSeleccionadoRef.current = data.placa;
					mapLeafletRef.current.querySelector('.leaflet-popup-close-button').onclick = () => {	// EVENTO PARA CUANDO SE DE CLICK EN LA "X" DEL POPUP
						placaMarcadorSeleccionadoRef.current = "";
					}
				})

				marcadoresMapaRef.current.push({placa: data.placa, marcador: marcadorCreado});
			})
		}
	},[trackUnidades])

	useEffect(() => {
		if(polilineas.length != 0){
			leafletClass.eliminarTodasLasPolilineas()
			polilineas.forEach((data,i) => {
				const puntosRecorrido = data.puntosRecorridoLineaMapa.split('*').map((data2,j) => [data2.split(',')[1],data2.split(',')[0]]);
				leafletClass.crearPolilinea({
					arrPuntos: puntosRecorrido,
					color: i == 0 ? '#0000FF' : '#FF0000',
					centrar: i == 0 ? true : false,
					ancho: 3,
					opacidad: 0.5
				})
			})
		}
	},[polilineas])

	const distanciaEntrePuntos = (lat1, lon1, lat2, lon2) => {
		const toRadians = (grados) => {
			return grados * (Math.PI / 180);
		}
		const radioTierra = 6371000.0;  //RADIO DE LA TIERRA EN METROS
		const lat1Rad = toRadians(lat1);
		const lon1Rad = toRadians(lon1);
		const lat2Rad = toRadians(lat2);
		const lon2Rad = toRadians(lon2);
		const dLat = lat2Rad - lat1Rad;
		const dLon = lon2Rad - lon1Rad;
		const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLon / 2) ** 2;
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const distancia = radioTierra * c;
		return distancia;   //RETORNA DISTANCIA ENTRE PUNTOS EN METROS
	}

	const dioClickMarcadorLeaflet = (placa) => {
		placaMarcadorSeleccionadoRef.current = placa
		const marcadorApertura = marcadoresMapaRef.current.find(elem => elem.placa == placa).marcador;
		leafletClass.centrarMarcador(marcadorApertura)
		leafletClass.abrirPopUpMarcador(marcadorApertura)
	}

	return (
	<>
		<section className='w-full h-full flex flex-col overflow-hidden'>
		<div className='h-[350px] relative'>
			{
			trackUnidades.length == 0 ? <ContenedorSkeleton></ContenedorSkeleton> : <></>
			} 
			<div ref={rafaRef} className={`${trackUnidades.length == 0 ? 'invisible' : ''} w-full border border-white h-[350px] relative bg-black`}>
			<div className='w-[150px] h-[20px] rounded-[50px] absolute animated-element-A bg-gradient-to-r from-black to-red-700 left-[100px] top-[320px]'></div>
			<div className='w-[150px] h-[20px] rounded-[50px] absolute animated-element-B bg-gradient-to-l to-red-700 from-black left-[100px] top-[10px]'></div>
				<Paper width={'100%'} height={350} attr={{'fill':'black'}}>
					<Set>
						<Rect x={40} y={65} width={anchoRectGrande} height={225} attr={{"fill":"black","stroke":"white","stroke-width":2,"r":10}}/>
						<Rect x={90} y={140} width={anchoRectPequenio} height={75} attr={{"fill":"black","stroke":"white","stroke-width":2,"r":10}}/>
						<Ellipse x={40} y={180} ry={13} rx={13} attr={{"fill":"#0f74ef","stroke":"white"}} />
						<Ellipse x={anchoRectGrande + 40} y={180} ry={13} rx={13} attr={{"fill":"#884dff","stroke":"white"}} />
						<Text x={40} y={180} text="A" attr={{ 'fill': 'white', 'font-size': 12, 'text-anchor': 'middle', 'alignment-baseline': 'middle' }} />
						<Text x={anchoRectGrande + 40} y={180} text="B" attr={{ 'fill': 'white', 'font-size': 12, 'text-anchor': 'middle', 'alignment-baseline': 'middle' }}/>
						
						{
							codEmpresa ? 
								<Text x={anchoRectPequenio/2 + 100} y={175} text={`" ${nombreEmpresaSeleccionada} - ${nombreRutaSeleccionada} "`} attr={{ "fill": 'white', "font-size": 22, "font-family": "Arial, Helvetica, sans-serif",}}/>
							:
								<Text x={anchoRectPequenio/2 + 100} y={175} text="Seleccionar una empresa" attr={{ "fill": 'white', "font-size": 20, "font-family": "Arial, Helvetica, sans-serif",}}/>
						}
						
						{
							verControlCompletoA && <Text x={anchoRectPequenio/2 + 100} y={335} text={nombreControlCompletoA} attr={{ "fill": 'green', "font-size": 13, "font-family": "Arial, Helvetica, sans-serif",}}/>
						}
						{
							verControlCompletoB && <Text x={anchoRectPequenio/2 + 100} y={15} text={nombreControlCompletoB} attr={{ "fill": 'green', "font-size": 13, "font-family": "Arial, Helvetica, sans-serif",}}/>
						}
						

						{
							controlesA.map((data,i) => {
								const sumaHasta = controlesA.slice(0, i+1).reduce((acumulador,elem) => {
									return (acumulador + elem.distanciaControlAnterior)
								},0)

								const posicionX = ((anchoRectPequenio * sumaHasta)/distanciaTotalA) + 100

								if(isNaN(posicionX))    return
								
								return(
									<React.Fragment key={i+1}>
										<Path d={[`M${posicionX} ${315}L${posicionX} ${291}`]} attr={{ 'stroke': 'white' }} />
										<Text x={posicionX - 8} y={304} text={data.abrev} attr={{ "fill": 'white', "font-size": 10, "font-family": "Arial, Helvetica, sans-serif", "transform": "r-90", 'cursor': 'pointer' }} mouseover={() => {setVerControlCompletoA(true);setNombreControlCompletoA(data.nomControl)}} mouseout={() => {setVerControlCompletoA(false)}}/>
									</React.Fragment>
								)
							})
						}

						{
							controlesB.map((data,i) => {
								const sumaHasta = controlesB.slice(0,i).reduce((acumulador,elem) => {
									return (acumulador + elem.distanciaControlAnterior)
								},0)

								const posicionX = ((anchoRectPequenio * sumaHasta)/distanciaTotalB) + 100

								if(isNaN(posicionX))    return

								return(
									<React.Fragment key={i+1}>
										<Path d={[`M${posicionX} ${64}L${posicionX} ${38}`]} attr={{ 'stroke': 'white' }} />
										<Text x={posicionX - 8} y={50} text={data.abrev} attr={{ "fill": 'white', "font-size": 10, "font-family": "Arial, Helvetica, sans-serif", "transform": "r-90", 'cursor': 'pointer' }} mouseover={() => {setVerControlCompletoB(true);setNombreControlCompletoB(data.nomControl)}} mouseout={() => {setVerControlCompletoB(false)}}/>
									</React.Fragment>
								)
							})
						}

						{
							trackUnidadesA.map((data,i) => {
								const controlAnterior = data.codControl
								
								if((controlesA.length != 0) && (controlesA.some(elem => elem.codControl == controlAnterior) || controlAnterior == 0)){
									const indiceControlAnterior = controlAnterior == 0 ? 0 : controlesA.findIndex(elem => elem.codControl == controlAnterior)
									const distanciaControlAnterior = distanciaEntrePuntos(data.latitudRegistro,data.longitudRegistro,controlesA[indiceControlAnterior].latitud,controlesA[indiceControlAnterior].longitud)
									const distanciaHastaControlAnterior = controlesA.slice(0,indiceControlAnterior + 1).reduce((acumulador,elem) => {
										return (acumulador + elem.distanciaControlAnterior)
									},0)

									const diferenciaPosicionAnterior = distanciaEntrePuntos(data.latitudRegistro,data.longitudRegistro,data.latitudRegistroAnterior,data.longitudRegistroAnterior)
									const posicionXAnterior = (((distanciaHastaControlAnterior + (distanciaControlAnterior - diferenciaPosicionAnterior)) * anchoRectPequenio) / distanciaTotalA) + 100 - 12
									const posicionX = (((distanciaHastaControlAnterior + distanciaControlAnterior) * anchoRectPequenio) / distanciaTotalA) + 100 - 12

									const posicionY = 250
									return(
										<React.Fragment key={i+1}>
											<Rect x={posicionXAnterior} y={posicionY} width={25} height={25} attr={{ "fill":"#032cfc" }} animate={Raphael.animation({"x": posicionX},2000,"<>")} />
											<Image src={carroA} x={posicionXAnterior} y={posicionY} width={25} height={25} attr={{'cursor':'pointer'}} animate={Raphael.animation({"x": posicionX},2000,"<>")} click={() => {dioClickMarcadorLeaflet(data.placa)}}/>
											<Text x={posicionXAnterior + 8} y={posicionY - 15} text={data.padron} attr={{ fill: 'white', "font-size": 11, 'cursor': 'pointer', "font-family": "Arial, Helvetica, sans-serif" , "transform": "r-90" }} animate={Raphael.animation({"y": (posicionY - 15 + (posicionX-posicionXAnterior))},2000,"<>")}/>
										</React.Fragment>
									)
								}
							})
						}

						{
							trackUnidadesB.map((data,i) => {
								const controlAnterior = data.codControl
								
								if((controlesB.length != 0) && (controlesB.some(elem => elem.codControl == controlAnterior || controlAnterior == 0))){
									const controlesB_reversa = controlesB.slice().reverse()
									const indiceControlAnterior = controlAnterior == 0 ? 0 : controlesB_reversa.findIndex(elem => elem.codControl == controlAnterior)
									const distanciaControlAnterior = distanciaEntrePuntos(data.latitudRegistro,data.longitudRegistro,controlesB_reversa[indiceControlAnterior].latitud,controlesB_reversa[indiceControlAnterior].longitud)
									const distanciaHastaControlAnterior = controlesB_reversa.slice(0,indiceControlAnterior + 1).reduce((acumulador,elem) => {
										return (acumulador + elem.distanciaControlAnterior)
									},0)

									const diferenciaPosicionAnterior = distanciaEntrePuntos(data.latitudRegistro,data.longitudRegistro,data.latitudRegistroAnterior,data.longitudRegistroAnterior)
									const posicionXAnterior = ((Math.max((distanciaTotalB - (distanciaControlAnterior + (distanciaHastaControlAnterior - diferenciaPosicionAnterior))),0) * anchoRectPequenio) / distanciaTotalB) + 100 - 12
									const posicionX = ((Math.max((distanciaTotalB - (distanciaControlAnterior + distanciaHastaControlAnterior)),0) * anchoRectPequenio) / distanciaTotalB) + 100 - 12
									
									const posicionY = 100
									return(
										<React.Fragment key={i+1}>
											<Rect x={posicionXAnterior} y={posicionY} width={25} height={25} attr={{ "fill": "#d90007" }} animate={Raphael.animation({"x": posicionX},2000,"<>")}/>
											<Image src={carroB} x={posicionXAnterior} y={posicionY} width={25} height={25} attr={{'cursor':'pointer'}} animate={Raphael.animation({"x": posicionX},2000,"<>")} click={() => {dioClickMarcadorLeaflet(data.placa)}} />
											<Text x={posicionXAnterior + 8} y={posicionY - 15} text={data.padron} attr={{ fill: 'white', "font-size": 11, 'cursor': 'pointer', "font-family": "Arial, Helvetica, sans-serif", "transform": "r-90" }} animate={Raphael.animation({"y": posicionY - 15 - (posicionXAnterior - posicionX)},2000,"<>")}/>
										</React.Fragment>
									)
								}
							})
						}

					</Set>
				</Paper>
			</div>
		</div>
		
		<div className='flex-1 flex overflow-auto'>
			<div className='w-1/2 h-full overflow-auto containerScroll relative'>
				{
				trackUnidades.length == 0 ? <ContenedorSkeleton></ContenedorSkeleton> : <></>
				} 
				<table className={`${trackUnidades.length == 0 ? 'invisible' : ''} table`}>
					<thead>
						<tr>
							<th>N°</th>
							<th>HORA</th>
							<th>UNIDAD</th>
							<th>ALERTA</th>
						</tr>
					</thead>
					<tbody>
						{
							alertas.length != 0 ?
								alertas.map((data,i) => {
									return (
										<tr key={i+1}>
											<td className='text-center'>{i+1}</td>
											<td className='text-center'>{data.hora}</td>
											<td className='text-center'>{data.padron}</td>
											<td className='flex justify-center'>
												<div className='flex items-center gap-3 w-full'>
													<i className='fa fa-circle' style={{color:`${data.color}`}} aria-hidden="true"></i>
													<div className=''>{data.alerta}</div>
												</div>
											</td>
										</tr>
									)
								})
							:   <tr><td colSpan="4" className='text-center'>No hay información para mostrar...</td></tr>
						}
					</tbody>
				</table>
			</div>
			<div className='w-1/2 h-full overflow-auto relative'>
				{/* {
				trackUnidades.length == 0 ? <ContenedorSkeleton></ContenedorSkeleton> : <></>
				}  */}
				<div ref={mapLeafletRef} className={` w-full h-full`}></div>
			</div>
		</div>
		</section>
	</>
	)
}

const ContenedorSkeleton = () => {
	return (
	<div className='absolute w-full h-full p-4 animate-pulse'>
		<div className='bg-gray-700 w-full h-full rounded-md flex items-center justify-center'>
			<svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
		</div>
	</div>
	)
}

export default ContenedorModalMonitoreo